import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';
import { SendAFormInteractive } from '../../SendAFormInteractiveState';

export type DropDownFieldProps = {
  valueUpdated: ValueChangedForFieldFunc;
  onActiveChanged: AnyFunc;
  editable?: boolean;
  value?: string;
  dropdownItems: TypeMePlease[];
  itemCollectionTemplateId?: string;
  allowOther?: boolean;
  overrideItemCollections?: TypeMePlease;
} & SendAFormInteractive;

export function getDropDownItems(dropdownItems, itemCollections, itemCollectionTemplateId) {
  let options = [];
  if (dropdownItems) {
    options = dropdownItems;
  } else if (itemCollections && itemCollectionTemplateId) {
    const itemCollection = itemCollections.find((p) => p.id === itemCollectionTemplateId);
    if (itemCollection) {
      options = itemCollection.items || [];
    }
  }
  return options;
}

export default function DropDownField(props: DropDownFieldProps) {
  let itemCollections = useSelector<TypeMePlease>((state) => state.formeditor.itemCollections);

  // the CalculationBuilder uses this component and doesn't have the redux state, so we want to manually pass it in
  itemCollections = props.overrideItemCollections || itemCollections;

  let options = [...getDropDownItems(props.dropdownItems, itemCollections, props.itemCollectionTemplateId)]
    .sort((a, b) => a.sortNumber - b.sortNumber)
    .map((item) => {
      return { value: item.value, text: item.displayName };
    });

  if (options && props.allowOther && props.value) {
    const matchingIndex = options.findIndex((x) => x.value === props.value);
    if (matchingIndex === -1) {
      // add currently selected value as top option
      options = [...[{ value: props.value, text: props.value }], ...options];
    }
  }

  return (
    <div className="field-value-dropdown">
      <Dropdown
        type="text"
        options={options}
        onChange={(e, data) => props.valueUpdated({ value: data.value?.toString() })}
        value={props.value || ''}
        selection
        search
        autoComplete="stop-autocomplete"
        searchInput={{ autoComplete: 'stop-autocomplete' }}
        className="field-value-dropdown"
        fluid
        disabled={!props.editable || !props.interactive}
        allowAdditions={props.allowOther}
        additionLabel="Use Custom: "
        onOpen={() => {
          if (props.onActiveChanged) {
            props.onActiveChanged(true);
          }
        }}
        onClose={() => {
          if (props.onActiveChanged) {
            props.onActiveChanged(false);
          }
        }}
      />
    </div>
  );
}
